import "./App.css";
import RemoteForm from "./components/RemoteForm";

function App() {
  return (
    <div className="App">
      <RemoteForm />
    </div>
  );
}

export default App;
